<br />
<img 
	class='system-logo' 
	src='assets/images/logos/tms-main.png' 
/>
<br />
<div 
	*ngIf="!isLogin" 
	class='login-container clearfix'
>
	<div 
		*ngIf="isError" 
		class="text-danger text-center"
	>{{ errorString }}</div>

	<form 
		#myForm 
		(submit)="onSubmit()" 
		[formGroup]="loginForm"
	>
		<div class='row'>
			<pcg-control-group 
				class="col-sm-12" 
				label="Username"
			>
				<input 
					pcgControlRef 
					formControlName="userName" 
					type="text" 
					class="form-control" 
				/>
			</pcg-control-group>
		</div>

		<div class='row'>		
			<pcg-show-hide-password 
				class="col-sm-12" 
				fcName="password" 
				[parentForm]="loginForm" 
				label="Password" 
				inputCssClass="form-control"
			></pcg-show-hide-password>
		</div>

		<button 
			type="submit" 
			class="btn btn-secondary btn-lg"
		>Login</button>
		<a 
			class='float-right' 
			routerLink='/forgot-password'
		>Forgot your password?</a>
	</form>
</div>

<div 
	*ngIf="
		isLogin 
		&& !isError
	" 
	class="login-container clearfix divider-content"
>
	<br />
	<div class="alert alert-warning text-center">
		Would you like to set up passwordless login? Press yes to continue or no to enter the site.
		<br /><br />
		<button 
			type="button" 
			class="btn btn-md btn-save" 
			(click)="yesClick()"
		>Yes</button>
		<br /><br />
		<button 
			type="button" 
			class="btn btn-md btn-cancel" 
			(click)="noClick()"
		>No</button>
	</div>
</div>